__turbopack_context__.v({
  "className": "geistsans_39ea2766-module__ShFT-W__className",
  "variable": "geistsans_39ea2766-module__ShFT-W__variable",
});
